"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationMiniOmnium = function IllustrationMiniOmnium() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M7.737 52h50"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M32.61 21.984v8.672"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    fillRule: "evenodd",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M48.219 24.19c-.948-1.425-2.813-2.395-4.958-2.395-2.473 0-4.574 1.29-5.326 3.08-.752-1.79-2.852-3.08-5.326-3.08-2.473 0-4.574 1.29-5.326 3.08-.751-1.79-2.852-3.08-5.326-3.08-2.145 0-4.01.97-4.957 2.395.764-6.753 7.46-12.034 15.61-12.034 8.148 0 14.845 5.28 15.609 12.034z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M34.054 12.445c3.18 3.18 3.758 12.141 3.758 12.141M31.164 12.445c-3.18 3.18-3.758 12.141-3.758 12.141M32.61 11v1.156"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.716 48.42h42.883a1.265 1.265 0 001.258-1.125l1.007-8.82a1.268 1.268 0 00-.685-1.272 1.254 1.254 0 00-.49-.133l-11.263-.662-5.165-7.836a1.26 1.26 0 00-1.1-.563l-16.455.68a1.254 1.254 0 00-1.148.874l-2.472 7.7-6.878.586a1.256 1.256 0 00-.842.428 1.267 1.267 0 00-.309.896l.416 8.056c.018.32.157.62.388.841.23.221.536.346.855.35z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.703 48.412h42.883a1.265 1.265 0 001.259-1.125l1.006-8.819a1.268 1.268 0 00-.684-1.273 1.255 1.255 0 00-.49-.132L43.412 36.4l-5.165-7.835a1.26 1.26 0 00-1.1-.564l-16.455.68a1.255 1.255 0 00-1.148.875l-2.471 7.699-6.88.586a1.257 1.257 0 00-.841.429 1.267 1.267 0 00-.308.896l.415 8.055c.018.32.157.62.388.842.23.22.536.346.855.349v0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M17.54 52.062c2.272 0 4.115-1.85 4.115-4.133 0-2.282-1.843-4.133-4.116-4.133-2.272 0-4.115 1.85-4.115 4.133 0 2.282 1.843 4.133 4.116 4.133zM47.324 52.062c2.273 0 4.115-1.85 4.115-4.133 0-2.282-1.842-4.133-4.115-4.133s-4.115 1.85-4.115 4.133c0 2.282 1.842 4.133 4.115 4.133z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M17.54 52.062c2.272 0 4.115-1.85 4.115-4.133 0-2.282-1.843-4.133-4.116-4.133-2.272 0-4.115 1.85-4.115 4.133 0 2.282 1.843 4.133 4.116 4.133zM47.324 52.062c2.273 0 4.115-1.85 4.115-4.133 0-2.282-1.842-4.133-4.115-4.133s-4.115 1.85-4.115 4.133c0 2.282 1.842 4.133 4.115 4.133z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6F558A",
    d: "M17.54 49.79a1.856 1.856 0 001.852-1.86c0-1.028-.83-1.861-1.852-1.861a1.857 1.857 0 00-1.853 1.86c0 1.028.83 1.86 1.853 1.86zM47.324 49.79a1.857 1.857 0 001.853-1.86c0-1.028-.83-1.861-1.853-1.861a1.856 1.856 0 00-1.852 1.86c0 1.028.829 1.86 1.852 1.86z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M9.21 42.626h2.266a.502.502 0 00.503-.506v-1.263a.507.507 0 00-.503-.506H9.087l.124 2.275zM55.363 42.626h-2.408a.502.502 0 01-.504-.506v-2.022a.507.507 0 01.504-.505h2.753l-.345 3.033zM30.737 31h6.23c.111 0 .221.03.315.09a.542.542 0 01.21.238l2.201 4.933a.504.504 0 01-.051.5.556.556 0 01-.204.175.597.597 0 01-.268.064h-8.433v-6zM27.737 31h-5.285c-.112 0-.22.04-.308.112a.537.537 0 00-.178.288l-1.213 4.933a.565.565 0 00.09.46.509.509 0 00.176.153.48.48 0 00.222.054h6.496v-6z"
  }));
};

var _default = IllustrationMiniOmnium;
exports.default = _default;